import React from 'react';
import { useParams } from 'react-router-dom';
import PermissionsForm from './PermissionsForm';

const EditPermissionPage = () => {
    // Get the dynamic 'id' from the URL
    const { id } = useParams();
    
    // Pass the id as a prop to the form component
    return <PermissionsForm formType="edit" currentPermissionId={id} />;
};

export default EditPermissionPage;

